/**
 * Built-in AutoCorrect list: common English typos that are never real words, mapped to their Australian
 * English correction. Keys and values are lower case; the editor keeps the typed capitalisation.
 */
const ENTRIES: ReadonlyArray<readonly [string, string]> = [
  ['teh', 'the'], ['hte', 'the'], ['adn', 'and'], ['nad', 'and'], ['taht', 'that'], ['thsi', 'this'], ['tihs', 'this'],
  ['waht', 'what'], ['wiht', 'with'], ['whith', 'with'], ['jsut', 'just'], ['knwo', 'know'], ['konw', 'know'],
  ['thier', 'their'], ['wich', 'which'], ['becuase', 'because'], ['becasue', 'because'], ['realy', 'really'],
  ['recieve', 'receive'], ['recieved', 'received'], ['recieves', 'receives'], ['recieving', 'receiving'],
  ['beleive', 'believe'], ['belive', 'believe'], ['acheive', 'achieve'], ['acheived', 'achieved'],
  ['definately', 'definitely'], ['seperate', 'separate'], ['seperately', 'separately'], ['occured', 'occurred'],
  ['occuring', 'occurring'], ['occurence', 'occurrence'], ['untill', 'until'], ['wierd', 'weird'],
  ['accomodate', 'accommodate'], ['accomodation', 'accommodation'], ['adress', 'address'], ['begining', 'beginning'],
  ['concious', 'conscious'], ['enviroment', 'environment'], ['existance', 'existence'], ['goverment', 'government'],
  ['freind', 'friend'], ['independant', 'independent'], ['neccessary', 'necessary'], ['neccessarily', 'necessarily'],
  ['noticable', 'noticeable'], ['occassion', 'occasion'], ['posession', 'possession'], ['recomend', 'recommend'],
  ['refered', 'referred'], ['relevent', 'relevant'], ['succesful', 'successful'], ['sucess', 'success'],
  ['tommorow', 'tomorrow'], ['tommorrow', 'tomorrow'], ['truely', 'truly'], ['aquire', 'acquire'],
  ['agressive', 'aggressive'], ['apparantly', 'apparently'], ['arguement', 'argument'], ['basicly', 'basically'],
  ['buisness', 'business'], ['commited', 'committed'], ['comming', 'coming'], ['completly', 'completely'],
  ['dissapear', 'disappear'], ['dissapoint', 'disappoint'], ['embarass', 'embarrass'], ['finaly', 'finally'],
  ['foriegn', 'foreign'], ['fourty', 'forty'], ['happend', 'happened'], ['immediatly', 'immediately'],
  ['knowlege', 'knowledge'], ['liason', 'liaison'], ['libary', 'library'], ['prefered', 'preferred'],
  ['priviledge', 'privilege'], ['probaly', 'probably'], ['responsability', 'responsibility'], ['suprise', 'surprise'],
  ['tendancy', 'tendency'], ['threshhold', 'threshold'], ['writting', 'writing'], ['yeild', 'yield'],
];

export const COMMON_TYPOS: ReadonlyMap<string, string> = new Map(ENTRIES);

/** The built-in correction for a typed word (any capitalisation), if it is a known typo. */
export function commonTypoCorrection(word: string): string | undefined {
  return COMMON_TYPOS.get(word.toLowerCase());
}
